import * as React from "react";
import {
  Button,
  Grid,
  Theme,
  IconButton,
  Box,
  Typography,
  makeStyles,
  createStyles,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import { useDispatch } from "react-redux";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useAppData } from "../../services/hooks";
import { hideRequiredFieldDialogAction } from "../../features/globalSlice";

interface DialogProps {
  message?: string | undefined;
  setErrorMessage: Function
}

export const RequiredFieldsDialog = (props: DialogProps) => {
  const { message, setErrorMessage } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const dialog = useAppData((r) => r.global.requiredFeildDialog);

  return (
    <Dialog fullWidth={true} maxWidth={"xs"} open={dialog.isVisible}>
      <DialogTitle>
        <Box sx={{display: "flex"}}>
          <Grid container justifyContent={"center"} alignItems={"center"}>
            <Grid item>
              <Typography variant="h6" component="h1">
                Required Fields
              </Typography>
            </Grid>
          </Grid>
          <Grid item>
            <IconButton
              aria-label="close"
              onClick={() => {
                dispatch(hideRequiredFieldDialogAction())
                setErrorMessage('');
              }}
            >
              <CloseIcon />
            </IconButton>
          </Grid>
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Typography className={classes.text}>
            {message || 'Required fields can not be empty. Please fill the required fields and try again.'}
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Box sx={{ padding: "10px 16px 24px 16px", width: "100%" }}>
          <Grid item>
            <Button
              fullWidth
              data-tut={"reactour__Submit"}
              variant="contained"
              color="primary"
              disabled={false}
              onClick={() => {
                dispatch(hideRequiredFieldDialogAction())
                setErrorMessage('');
              }}
            >
              OK
            </Button>
          </Grid>
        </Box>
      </DialogActions>
    </Dialog>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    autoCompleteWrapper: {
      "& .MuiButtonBase-root-MuiCheckbox-root": {
        color: "red",
      },
      "& .MuiAutocomplete-noOptions": {
        color: theme.palette.text.primary,
      },
    },
    text: {
      color: theme.palette.text.primary,
    },
  })
);
